import Repository from "./Repository";

export default {
  getManager(id) {
    return Repository.get(`/manager-earning-stats/${id}`);
  },
};
